/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AggregateValue } from './AggregateValue';
import type { FutureShareValue } from './FutureShareValue';
import type { PresentShareValue } from './PresentShareValue';
export type ValuationApproachFutureExit = {
  readonly id?: number;
  valuation_approach: number;
  present_share_values?: Array<PresentShareValue>;
  future_share_values?: Array<FutureShareValue>;
  aggregate_values?: Array<AggregateValue>;
  deleted_present_share_value_ids?: Array<number>;
  deleted_future_share_value_ids?: Array<number>;
  deleted_aggregate_value_ids?: Array<number>;
  financials_metric: ValuationApproachFutureExit.financials_metric;
  referenced_approach_multiple: ValuationApproachFutureExit.referenced_approach_multiple;
  readonly last_audit_event_id?: string | null;
  is_deleted?: boolean | null;
  readonly deleted_at?: string | null;
  financials_metric_value?: string | null;
  referenced_approach_multiple_value?: string | null;
  less_debt?: string | null;
  plus_cash?: string | null;
  present_enterprise_value?: string | null;
  discount_rate?: string | null;
  dilution_percentage?: string | null;
  exit_date?: string | null;
  allocation_method?: ValuationApproachFutureExit.allocation_method | null;
  maturity?: string | null;
  volatility?: string | null;
  risk_free_rate?: string | null;
  future_equity_value?: string | null;
  is_future_exit_calculated?: boolean;
  valuation_approach_gpc?: number | null;
  valuation_approach_gpt?: number | null;
  volatility_source?: number | null;
  cap_table?: number | null;
};
export namespace ValuationApproachFutureExit {
  export enum financials_metric {
    SPECIFIED_LTM_REVENUE = 'Specified LTM Revenue',
    SPECIFIED_LTM_EBITDA = 'Specified LTM EBITDA',
    SPECIFIED_NTM_REVENUE = 'Specified NTM Revenue',
    SPECIFIED_NTM_EBITDA = 'Specified NTM EBITDA',
    LTM_REVENUE = 'LTM Revenue',
    NTM_REVENUE = 'NTM Revenue',
    LTM_EBITDA = 'LTM EBITDA',
    NTM_EBITDA = 'NTM EBITDA',
    LTM_ADJUSTED_EBITDA = 'LTM Adjusted EBITDA',
    NTM_ADJUSTED_EBITDA = 'NTM Adjusted EBITDA',
  }
  export enum referenced_approach_multiple {
    SPECIFIED = 'Specified',
    SPECIFIED_MULTIPLE = 'Specified Multiple',
    MEDIAN = 'Median',
    MEAN = 'Mean',
    _25TH_PERCENTILE = '25th Percentile',
    _75TH_PERCENTILE = '75th Percentile',
    SELECTION_A = 'Selection A',
    SELECTION_B = 'Selection B',
  }
  export enum allocation_method {
    '_0' = 0,
    '_1' = 1,
    '_2' = 2,
  }
}

